var $f195635a1f9154fe$exports = {};
$f195635a1f9154fe$exports = {
    "collectionLabel": `Suggestions`
};


export {$f195635a1f9154fe$exports as default};
//# sourceMappingURL=en-US.module.js.map
